import { render, staticRenderFns } from "./QuizesTableNew.vue?vue&type=template&id=0b4afc46&scoped=true&"
import script from "./QuizesTableNew.vue?vue&type=script&lang=js&"
export * from "./QuizesTableNew.vue?vue&type=script&lang=js&"
import style0 from "./QuizesTableNew.vue?vue&type=style&index=0&id=0b4afc46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4afc46",
  null
  
)

export default component.exports